export const resolveAssetUrl = (url, fallback = '') => {
  const value = url || fallback;
  if (!value) return '';
  if (/^(https?:|data:|blob:)/i.test(value)) return value;

  const baseUrl = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
  if (baseUrl && value.startsWith('/uploads/')) return `${baseUrl}${value}`;

  return value;
};
